import type { ApolloError } from '@apollo/client';
import { createTelemetry } from '@shared/core/analytics/telemetry';

const category = 'GuestGuide';

const { TelemetryProvider: GuestGuideTelemetryProvider, useTelemetry: useGuestGuideTelemetry } = createTelemetry({
  pages: {
    remindMeLaterDialog: () => ({
      category,
      name: 'guest.wedding.guestGuide.remindMeLaterDialog',
      page: 'remindMeLaterDialog',
      pagePrefix: 'guest',
    }),
  },
  actions: {
    guideShown: () => ({
      action: 'GuestGuideShown',
      category,
    }),
    clickAddToCalendar: () => ({
      action: 'AddToCalendar',
      actionType: 'click',
      category,
    }),
    clickEditRsvp: () => ({
      action: 'EditRsvp',
      actionType: 'click',
      category,
    }),
    clickBrowseHotels: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'BrowseHotelsClicked',
        from: 'GuestGuide',
      },
    }),
    clickCarRentals: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        from: 'GuestGuide',
        name: 'CarRentalsClicked',
      },
    }),
    clickBookingCta: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'BookingCtaClicked',
        from: 'GuestGuide',
      },
    }),
    clickBrowseRegistry: () => ({
      action: 'BrowseRegistry',
      actionType: 'click',
      category,
    }),
    clickRemindMeToBookStay: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'RemindMeToBookStayClicked',
        from: 'GuestGuide',
      },
    }),
    formFieldInteracted: (label: string, inputAction: 'onFocus' | 'onChange') => ({
      category,
      action: 'FormFieldInteracted',
      label,
      inputAction,
      extraInfo: {
        name: 'remind_to_book',
      },
    }),
    remindMeLaterFormSubmitted: (duration: string, reminderDate: string) => ({
      category,
      action: 'FormSubmitted',
      extraInfo: {
        duration,
        reminderDate,
        name: 'remind_to_book',
      },
    }),
    remindMeLaterDialogDismissed: () => ({
      category,
      action: 'GuestGuideButtonInteracted',
      extraInfo: {
        name: 'remind_to_book_dismiss_cta',
      },
    }),
    remindMeLaterDialogOutsideClick: () => ({
      category,
      action: 'GuestGuideButtonInteracted',
      extraInfo: {
        name: 'remind_to_book_dismiss_click_outside',
      },
    }),
    clickPriceAlerts: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'PriceAlertsClicked',
        from: 'GuestGuide',
      },
    }),
    priceAlertPhoneSubmitted: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'PriceAlertPhoneSubmitted',
        from: 'GuestGuide',
      },
    }),
    priceAlertOtpSubmitted: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'PriceAlertOtpSubmitted',
        from: 'GuestGuide',
      },
    }),
    priceAlertSubscriptionCreated: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'PriceAlertSubscriptionCreated',
        from: 'GuestGuide',
      },
    }),
    priceAlertDismissed: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'price_alert_dismiss',
        from: 'GuestGuide',
      },
    }),
    priceAlertAccommodationsCtaClicked: () => ({
      action: 'TravelButtonInteracted',
      category,
      extraInfo: {
        name: 'price_alert_accommodations_cta',
        from: 'GuestGuide',
      },
    }),
    priceAlertFormFieldInteracted: (label: string, inputAction: 'onFocus' | 'onChange') => ({
      category,
      action: 'TravelButtonInteracted',
      label,
      inputAction,
      extraInfo: {
        name: 'price_alert',
        from: 'GuestGuide',
      },
    }),
    clickLogout: () => ({
      action: 'Logout',
      actionType: 'click',
      category,
    }),
    trackError: (action: string, error: ApolloError | Error | unknown, extra = {}) => ({
      category,
      action,
      actionType: 'error',
      extraInfo: { error, ...extra },
    }),
  },
});
export { GuestGuideTelemetryProvider, useGuestGuideTelemetry };
